module.exports = __webpack_public_path__ + "static/week_week5_spot3-c69196904a914a24cbb835f532729886.jpg";